module.exports = __webpack_public_path__ + "img/php.4571edd0.svg";